// registration-wizard/FacilitatorsStep.tsx
import { Stack, Select, MultiSelect } from '@mantine/core';

export interface FacilitatorOption {
  value: string;
  label: string;
}

export interface FacilitatorsStepProps {
  facilitatorData: FacilitatorOption[];
  loadingFacilitators: boolean;
  facilitatorUserIds: string[];
  onFacilitatorChange: (ids: string[]) => void;
  leadFacilitatorUserId: string | null;
  onLeadFacilitatorChange: (id: string | null) => void;
}

export function FacilitatorsStep({
  facilitatorData,
  loadingFacilitators,
  facilitatorUserIds,
  onFacilitatorChange,
  leadFacilitatorUserId,
  onLeadFacilitatorChange,
}: FacilitatorsStepProps) {
  return (
    <Stack gap="md">
      <MultiSelect
        label="Facilitators"
        placeholder={loadingFacilitators ? 'Loading facilitators…' : 'Select facilitators'}
        data={facilitatorData}
        value={facilitatorUserIds}
        onChange={onFacilitatorChange}
        searchable
        disabled={loadingFacilitators}
      />

      <Select
        label="Lead Facilitator"
        placeholder="Select the lead facilitator"
        data={facilitatorData.filter((f) => facilitatorUserIds.includes(f.value))}
        value={leadFacilitatorUserId}
        onChange={onLeadFacilitatorChange}
        disabled={facilitatorUserIds.length === 0}
        clearable
      />
    </Stack>
  );
}

export default FacilitatorsStep;